/* Next */
import Link from 'src/components/Link'
import { hrefForBrandPath } from 'src/functions/navigationBreadcrumbs'

/* Material */
import Typo from '@mui/material/Typography'

import useStyles from './Brands.styles'

/* Types */
import { tBrands } from 'src/shared/frontendTypes/brand'

const Brands = (props:{brands:tBrands}) => {
  const { brands } = props
  const classes = useStyles()

  const initial = (title: string) => title.trim().charAt(0).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleUpperCase('de')
  const groupForBrand = (title: string) => /^[A-Z]$/.test(initial(title)) ? initial(title) : '#'
  const letters = [...new Array(26).fill(1).map((_, i) => String.fromCharCode(65 + i)), '#']
  const sortedBrands = [...brands].sort((a, b) => a.titel.localeCompare(b.titel, 'de', { sensitivity: 'base' }))

  return <div className={classes.brandList}>
    
    {letters.map(letter => (

      sortedBrands.some(b=> groupForBrand(b.titel) === letter) &&

        <div key={letter}>

          <Typo component='h2' variant='h4' color='inherit' gutterBottom>
            {letter}
          </Typo>

          <ul>
            {sortedBrands
              .filter(
                b=> groupForBrand(b.titel) === letter
              )
              .map(brand =>
                <li key={brand.id}>
                  <Link legacyBehavior href={hrefForBrandPath(brand.path, brand.id) || '/brands'}><a>
                    {brand.titel}
                  </a></Link>
                </li>
            )}
          </ul>

        </div>
        
    ))}

  </div>

}

export default Brands
